module.exports = __webpack_public_path__ + "static/media/rasm.a9c88a80.gif";